module.exports = __webpack_public_path__ + "static/media/Programming.d5830e10.svg";